export * from './lib/shared-svg-icons.module';
